<template>
  <div class="flex-col page">
    <img src="https://ysh-cdn.kaidicloud.com/test/2024/05/07/1f441c296d824c3abb68e40f7bba4476.png" alt="" class="header-bg" />

    <div class="flex-col flex-auto group_3" style="padding-top: 100px">
      <div v-for="(item, index) in blockList" :key="index">
        <two-card v-if="item.type === MODULE_TYPE.TWO_CARD && item.content.length" :content="item.content" />
        <hero-section v-else-if="item.type === MODULE_TYPE.KINGKONG" :content="getModelContent(MODULE_TYPE.KINGKONG)" />
        <div v-else-if="item.type === MODULE_TYPE.BANNER && item.content.bannerList?.length" class="flex-col view space-y-12">
          <banner :content="item.content" />
        </div>
        <div v-else-if="item.type === MODULE_TYPE.CHAMBER && item.dataList.length" class="flex-col group_5 view space-y-12">
          <Chamber :dataList="item.dataList" :content="item.content" />
        </div>
        <div v-else-if="item.type === MODULE_TYPE.CONTACT && item.dataList.length" class="flex-col group_5 view space-y-12">
          <net-connect :dataList="item.dataList" :content="item.content" />
        </div>
        <div v-else-if="item.type === MODULE_TYPE.ACTIVITY && item.content.length" class="flex-col group_5 view space-y-12">
          <live-activity :content="item.content" />
        </div>
        <div
          v-else-if="item.type === MODULE_TYPE.DEMAND && item.dataList.length && ((item.dataList.length && !item.content[0].hotDemand) || item.content[0].hotDemand)"
          class="flex-col group_5 view space-y-12"
        >
          <demand :dataList="item.dataList" :content="item.content" />
        </div>
        <div v-else-if="item.type === MODULE_TYPE.YYDS && item.content.length" class="flex-col group_5 view space-y-12">
          <yyds-goods :content="item.content" />
        </div>
        <div v-else-if="item.type === MODULE_TYPE.COURSE && item.content.length" class="flex-col group_5 view space-y-12">
          <college :content="item.content" />
        </div>
        <home-tabs :content="item.content" v-else-if="item.type === MODULE_TYPE.TAB && item.content.length" />
      </div>
    </div>
  </div>
</template>

<script>
import { getHomepageVersion, getModuleList, getKingKongList, getTabsList, getBannerList, getChamberList, getOldChamberList, getContactList, getOldContactList, getDemandHotList } from '@/api/preview'
import { Toast } from 'vant'
import TwoCard from './TwoCard.vue'
import HeroSection from './HeroSection.vue'
import Banner from './Banner.vue'
import Chamber from './Chamber.vue'
import NetConnect from './NetConnect.vue'
import LiveActivity from './LiveActivity.vue'
import Demand from './Demand.vue'
import YydsGoods from './YydsGoods.vue'
import College from './College.vue'
import { MODULE_STATUS, MODULE_TYPE } from './constant'
import HomeTabs from './HomeTabs.vue'
export default {
  components: { Chamber, TwoCard, HeroSection, Banner, NetConnect, LiveActivity, Demand, YydsGoods, College, HomeTabs },
  props: {},
  data() {
    return {
      /** 页面模块列表数据 */
      blockList: [],
      MODULE_TYPE,
    }
  },
  created() {
    if (this.isOnline) {
      this.getHomePageGetOne()
    } else {
      this.getPreviewData()
    }
  },
  computed: {
    isOnline() {
      return this.$route.query?.type === 'online'
    },
  },
  methods: {
    getModelContent(type) {
      return this.blockList?.find((v) => v.type === type)?.content || []
    },

    /** 获取金刚区数据 */
    async getKingKongData() {
      const { data } = await getKingKongList()
      return data.data
    },
    /** 获取tab区数据 */
    async geTabData() {
      const { data } = await getTabsList()
      return data.data
    },
    /** 获取banner区数据 */
    async getBannerData() {
      const { data } = await getBannerList()
      return data.data
    },
    /** 获取社会组织区数据 */
    async getChamberData(config) {
      const { chamberListFlag, moduleId } = config || {}
      const fetchApi = chamberListFlag ? getOldChamberList : getChamberList
      const { data } = await fetchApi({ moduleId, page: 1, pageSize: 30 })
      return chamberListFlag ? data.data : data.data.list
    },
    /** 获取人脉名录区数据 */
    async getContactData(config) {
      const { contactsDirectory } = config || {}
      const fetchApi = contactsDirectory ? getOldContactList : getContactList
      const { data } = await fetchApi({ page: 1, pageSize: 30 })
      return contactsDirectory ? data.data.list : data.data
    },
    /** 获取人脉名录区数据 */
    async getDemandData(config) {
      const { hotDemand } = config || {}
      const { data } = await getDemandHotList({ page: 1, pageSize: 3, hotHidden: hotDemand })
      return data.data.list
    },
    /** 获取预发布数据 */
    async getPreviewData() {
      const { data } = await getModuleList()

      for (const item of data.data.filter((v) => v.status === MODULE_STATUS.NORMAL)) {
        item.type = item.moduleType
        if (item.type === MODULE_TYPE.KINGKONG) {
          item.content = await this.getKingKongData()
        } else if (item.type === MODULE_TYPE.TAB) {
          item.content = await this.geTabData()
        } else if (item.type === MODULE_TYPE.BANNER) {
          item.content = await this.getBannerData()
        } else if (item.type === MODULE_TYPE.CHAMBER) {
          item.dataList = await this.getChamberData({ ...item.extendVO, moduleId: item.id })
          console.log('item.dataList', item.dataList)
          item.content = item.extendVO ? [item.extendVO] : []
          console.log('item.content', item.content)
        } else if (item.type === MODULE_TYPE.CONTACT) {
          const contactsDirectory = item.extendVO ? item.extendVO.contactsDirectory : false
          const list = await this.getContactData(item.extendVO)
          item.dataList = contactsDirectory ? list : list.filter((v) => v.status === MODULE_STATUS.NORMAL)
          item.content = item.extendVO ? [item.extendVO] : []
        } else if (item.type === MODULE_TYPE.DEMAND) {
          item.dataList = await this.getDemandData(item.extendVO)
          item.content = item.extendVO ? [item.extendVO] : []
        } else {
          item.content = item.extendVO ? [item.extendVO] : []
        }
      }

      this.blockList = data.data.filter((v) => v.status === MODULE_STATUS.NORMAL)
    },
    // 首页版本数据
    async getHomePageGetOne() {
      const { data } = await getHomepageVersion()
      try {
        const blockList = JSON.parse(data.data.content)
        for (const v of blockList) {
          if (v.content) {
            if (v.type === MODULE_TYPE.BANNER) {
              v.content = {
                bannerList: JSON.parse(v.content),
                bannerTime: v.bannerTime,
              }
            } else if (v.type === MODULE_TYPE.CHAMBER) {
              v.content = JSON.parse(v.content)
              v.dataList = await this.getChamberData(v.content[0])
            } else if (v.type === MODULE_TYPE.CONTACT) {
              v.content = JSON.parse(v.content)
              v.dataList = await this.getContactData()
            } else if (v.type === MODULE_TYPE.DEMAND) {
              v.content = JSON.parse(v.content)
              v.dataList = await this.getDemandData(v.content[0])
            } else {
              v.content = JSON.parse(v.content)
            }
          }
        }
        this.blockList = blockList
      } catch (error) {
        Toast(`获取数据失败,${error}`)
      }
    },
  },
}
</script>

<style lang="less">
::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none;
}
</style>

<style lang="less" scoped>
.header-bg {
  position: absolute;
  width: 100%;
  height: 232px;
}

.card-wrap {
  padding: 32px 0;
  background: #fff;
  border-radius: 40px;
}
.page {
  position: relative;
  background-color: #f6f6f6;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  min-height: 100vh;
  .header {
    background-color: #ffffff;
    .section {
      padding: 34px 32px 16px;
      background-image: url('https://ysh-cdn.kaidicloud.com/codefun/preview/4aad3831b341408f62c4fafd5c649b1d.png');
      background-position: 0% 0%;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .group {
        padding-left: 36px;
        .text {
          color: #000000;
          font-size: 30px;
          font-family: '.AppleSystemUIFont';
          line-height: 36px;
          letter-spacing: -0.5px;
        }
      }
      .group_2 {
        width: 102px;
        .image_5 {
          width: 80px;
          height: 64px;
        }
        .image_6 {
          border-radius: 50%;
          width: 64px;
          height: 64px;
        }
        .pos {
          position: absolute;
          right: 6px;
          top: 0;
        }
      }
      .section_2 {
        margin: 4px 0 4px 12px;
        padding: 8px 16px;
        background-color: #ffffff;
        backdrop-filter: blur(8px);
        border-radius: 32px;
        height: 64px;
        border: solid 2px #3273f4;
        .text_3 {
          color: #999999;
        }
      }
      .space-x-6 {
        & > *:not(:first-child) {
          margin-left: 12px;
        }
        .image {
          width: 34px;
          height: 22px;
        }
        .image_2 {
          width: 30px;
          height: 22px;
        }
        .image_3 {
          width: 49px;
          height: 23px;
        }
      }
      .image_4 {
        margin-left: 24px;
        margin-right: 4px;
        width: 72px;
        height: 72px;
      }
    }
  }
  .group_3 {
    overflow-y: auto;

    .group_5 {
      padding: 0 32px;
    }

    .section_8 {
      padding: 24px;
      background-color: #ffffff;
      border-radius: 16px;
      .space-x-9 {
        & > *:not(:first-child) {
          margin-left: 18px;
        }
      }
      .text_14 {
        font-size: 26px;
        line-height: 36px;
      }
      .image_16 {
        border-radius: 8px;
        width: 180px;
        height: 108px;
      }
      .group_15 {
        border-radius: 12px;
        width: 224px;
        height: 128px;
        .text-wrapper_5 {
          padding: 4px 0;
          background-color: #00000080;
          border-radius: 12px 0px 12px 0px;
          .text_22 {
            margin: 0 8px;
          }
        }
        .pos_7 {
          position: absolute;
          left: 0;
          top: 0;
        }
        .pos_8 {
          position: absolute;
          left: 0;
          top: 0;
        }
      }
      .group_16 {
        margin: 0 16px;
        .text_23 {
          text-align: justify;
        }
      }
      .group_17 {
        margin: 4px 16px;
      }
      .space-y-22 {
        & > *:not(:first-child) {
          margin-top: 44px;
        }
      }
    }
    .space-y-9 {
      & > *:not(:first-child) {
        margin-top: 18px;
      }
    }
    .font_5 {
      font-size: 24px;
      font-family: 'PingFang SC';
      line-height: 34px;
      color: #999999;
    }
    .space-y-4 {
      & > *:not(:first-child) {
        margin-top: 8px;
      }
    }
    .space-x-8 {
      & > *:not(:first-child) {
        margin-left: 16px;
      }
      .section_9 {
        background-color: #f0eded;
        width: 2px;
        height: 23px;
      }
      .font_9 {
        font-size: 24px;
        font-family: 'PingFang SC';
        line-height: 34px;
        color: #e77600;
      }
    }
    .section_10 {
      padding: 24px 0 14px;
      background-color: #ffffff;
      border-radius: 16px;
      .space-x-20 {
        & > *:not(:first-child) {
          margin-left: 40px;
        }
      }
    }
    .text_17 {
      font-size: 26px;
      line-height: 36px;
    }
    .horiz-list {
      margin-top: 14px;
      .horiz-list-item {
        flex-shrink: 0;
        .group_13 {
          border-radius: 12px;
          .pos_6 {
            position: absolute;
            left: 12px;
            top: 12px;
          }
        }
      }
      .group_10 {
        padding: 8px 0;
        width: 274px;
      }
      .group_11 {
        flex-shrink: 0;
        margin-left: 24px;
        .image_14 {
          width: 82px;
          height: 152px;
        }
        .text_13 {
          text-align: justify;
        }
      }
      .horiz-list-item_2 {
        padding: 8px 0;
        .font_12 {
          font-size: 20px;
          font-family: 'PingFang SC';
          line-height: 28px;
          font-weight: 500;
          color: #f93809;
        }
        .font_11 {
          font-size: 40px;
          font-family: 'DIN Alternate';
          line-height: 48px;
          font-weight: 700;
          color: #f93809;
        }
        .text_21 {
          margin-left: 12px;
          margin-top: 14px;
          text-decoration: line-through;
        }
      }
      .image_13 {
        border-radius: 12px;
        width: 274px;
        height: 152px;
      }
      .text_12 {
        text-align: justify;
        width: 252px;
      }
      .group_12 {
        padding: 8px 0;
        width: 252px;
      }
      .group_14 {
        flex: 1 1 234px;
        .image_17 {
          border-radius: 12px;
          width: 180px;
          height: 180px;
        }
        .text_18 {
          margin-top: 16px;
          text-align: left;
        }
        .text_19 {
          width: 168px;
        }
        .text-wrapper_4 {
          margin-top: 8px;
          border-radius: 4px;
          height: 32px;
          border: solid 1px #daab67;
          .font_10 {
            font-size: 24px;
            font-family: 'PingFang SC';
            line-height: 28px;
            font-weight: 500;
            color: #daab67;
          }
          .text_20 {
            margin: 0 8px;
            font-size: 22px;
            line-height: 30px;
          }
        }
      }
      .equal-division-item {
        padding: 8px 24px 0;
      }
    }
    .space-x-5 {
      & > *:not(:first-child) {
        margin-left: 10px;
      }
      .text-wrapper_3 {
        background-color: #fa6400;
        border-radius: 4px;
        width: 56px;
        height: 32px;
        .text_16 {
          font-size: 22px;
          line-height: 32px;
        }
      }
      .image_18 {
        width: 24px;
        height: 28px;
      }
    }
    .view {
      margin-top: 24px;
    }
    .font_3 {
      font-size: 24px;
      font-family: 'PingFang SC';
      line-height: 34px;
      color: #222222;
    }
    .group_18 {
      padding: 0 12px 24px 24px;
      .group_19 {
        padding: 24px 0 6px;
        .text_24 {
          color: #f93809;
          font-size: 36px;
          line-height: 50px;
        }
        .font_13 {
          font-size: 30px;
          font-family: 'PingFang SC';
          line-height: 40px;
          color: #222222;
        }
        .text_25 {
          line-height: 42px;
        }
        .text_26 {
          line-height: 42px;
        }
        .text_27 {
          line-height: 42px;
        }
        .text_28 {
          line-height: 42px;
        }
      }
      .section_11 {
        margin-left: 16px;
        background-color: #f93809;
        border-radius: 3px;
        width: 40px;
        height: 6px;
      }
    }
    .font_4 {
      font-size: 34px;
      font-family: 'PingFang SC';
      line-height: 48px;
      font-weight: 500;
      color: #222222;
    }
    .group_20 {
      padding: 0 24px 72px;
      height: 1823px;
      .section_12 {
        padding: 16px;
        border-radius: 12px;
        background-image: url('https://ysh-cdn.kaidicloud.com/codefun/preview/45b40785e090fa4ed59f35c2f2e1e1b1.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 338px;
        .text-wrapper_6 {
          background-image: linear-gradient(299.7deg, #ff7615 0%, #ff7615 -20.06%, #ffa21f 120.06%, #ffa21f 100%);
          border-radius: 4px;
          width: 56px;
          .text_29 {
            font-weight: 500;
          }
        }
      }
      .space-y-44 {
        & > *:not(:first-child) {
          margin-top: 88px;
        }
      }
      .pos_9 {
        position: absolute;
        left: 24px;
        top: 0;
      }
      .section_14 {
        padding-top: 112px;
        overflow: hidden;
        border-radius: 12px;
        background-image: url('https://ysh-cdn.kaidicloud.com/codefun/preview/0e7c9056f50ebac9dba82118cfd66c5d.png');
        background-position: 0% 0%;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 338px;
        .image_20 {
          width: 92px;
          height: 94px;
        }
        .section_15 {
          padding: 40px 18px 18px;
          background-image: linear-gradient(180deg, #00000000 0%, #000000e6 74.67%, #000000e6 100%);
          border-radius: 0px 0px 12px 12px;
          .text_30 {
            color: #ffffff;
            line-height: 42px;
            text-align: left;
          }
        }
      }
      .space-y-58 {
        & > *:not(:first-child) {
          margin-top: 116px;
        }
      }
      .pos_11 {
        position: absolute;
        left: 24px;
        top: 184px;
      }
      .section_13 {
        padding: 16px 0 472px;
        border-radius: 12px;
        background-image: url('https://ysh-cdn.kaidicloud.com/codefun/preview/ab26022fd92b701ae5fc5c239b88af36.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 338px;
        .view_2 {
          margin-left: 16px;
        }
      }
      .pos_10 {
        position: absolute;
        right: 24px;
        top: 0;
      }
      .image_23 {
        border-radius: 12px 12px 0 0;
        width: 338px;
        height: 280px;
      }
      .pos_13 {
        position: absolute;
        left: 24px;
        top: 728px;
      }
      .section_16 {
        padding: 20px 18px;
        background-color: #ffffff;
        border-radius: 0px 0px 12px 12px;
        width: 338px;
        .text_31 {
          line-height: 42px;
        }
      }
      .pos_14 {
        position: absolute;
        left: 24px;
        top: 1008px;
      }
      .font_14 {
        font-size: 30px;
        font-family: 'PingFang SC';
        line-height: 40px;
        font-weight: 500;
        color: #222222;
      }
      .image_21 {
        border-radius: 12px;
        width: 338px;
        height: 520px;
      }
      .pos_12 {
        position: absolute;
        right: 24px;
        top: 544px;
      }
      .image_24 {
        border-radius: 12px 12px 0 0;
        width: 338px;
        height: 374px;
      }
      .pos_16 {
        position: absolute;
        left: 24px;
        bottom: 283px;
      }
      .pos_17 {
        position: absolute;
        left: 24px;
        top: 1540px;
      }
      .pos_15 {
        position: absolute;
        right: 30px;
        bottom: 215px;
      }
      .section_17 {
        background-image: linear-gradient(268.6deg, #e8e8e800 0%, #e8e8e800 5.28%, #cccccc 117.08%, #cccccc 100%);
        width: 40px;
        height: 2px;
      }
      .pos_20 {
        position: absolute;
        left: 241px;
        top: 1730px;
      }
      .text_32 {
        color: #cccccc;
        font-size: 26px;
        line-height: 36px;
      }
      .pos_19 {
        position: absolute;
        left: 50%;
        bottom: 73px;
        transform: translateX(-50%);
      }
      .section_18 {
        background-image: linear-gradient(91.4deg, #e8e8e800 0%, #e8e8e800 5.28%, #cccccc 117.08%, #cccccc 100%);
        width: 40px;
        height: 2px;
      }
      .pos_21 {
        position: absolute;
        right: 241px;
        top: 1730px;
      }
      .image_25 {
        overflow: hidden;
        width: 120px;
        height: 126px;
      }
      .pos_18 {
        position: absolute;
        right: 40px;
        bottom: 81px;
      }
    }
    .font_6 {
      font-size: 20px;
      font-family: 'PingFang SC';
      line-height: 28px;
      color: #ffffff;
    }
    .image_19 {
      width: 48px;
      height: 6px;
    }
    .space-y-8 {
      & > *:not(:first-child) {
        margin-top: 16px;
      }
    }
    .space-x-4 {
      & > *:not(:first-child) {
        margin-left: 8px;
      }
      .text-wrapper_2 {
        background-color: #0091ff;
        border-radius: 4px;
        width: 56px;
        height: 32px;
        .text_15 {
          font-size: 22px;
          line-height: 32px;
        }
      }
      .image_22 {
        border-radius: 50%;
        width: 40px;
        height: 40px;
      }
    }
    .font_8 {
      font-size: 24px;
      font-family: 'PingFang SC';
      line-height: 34px;
      color: #ffffff;
    }
    .section_7 {
      padding: 2px 8px;
      background-image: linear-gradient(108.4deg, #fb6d3d 0%, #fb6d3d -20.71%, #f23f4e 120.71%, #f23f4e 100%);
      border-radius: 6px;
      .image_15 {
        width: 16px;
        height: 16px;
      }
    }
    .space-y-6 {
      & > *:not(:first-child) {
        margin-top: 12px;
      }
    }
    .font_7 {
      font-size: 24px;
      font-family: 'PingFang SC';
      line-height: 34px;
      color: #666666;
    }
  }
  .space-y-12 {
    & > *:not(:first-child) {
      margin-top: 24px;
    }
  }
  .image_7 {
    width: 36px;
    height: 36px;
  }
  .font_2 {
    font-size: 28px;
    font-family: 'PingFang SC';
    line-height: 40px;
    color: #222222;
  }
  .tab-bar {
    padding: 0 40px 8px;
    background-color: #ffffff;
    border-top: solid 2px #f5f5f5;
    .image-wrapper {
      width: 69px;
      .image_26 {
        width: 54px;
        height: 54px;
      }
      .font_15 {
        font-size: 20px;
        font-family: 'PingFang SC';
        line-height: 28px;
        color: #333333;
      }
      .text_33 {
        margin-left: 8px;
      }
    }
  }
  .text-wrapper {
    position: absolute;
    right: 0;
    top: 0;
    .font_1 {
      font-size: 24px;
      font-family: 'Helvetica';
      line-height: 28px;
      color: #ffffff;
    }
    .text_2 {
      line-height: 26px;
    }
  }
  .badge {
    background-image: linear-gradient(135deg, #fd6915 0%, #fd6915 -20.71%, #f93809 120.71%, #f93809 100%);
    border-radius: 15px;
    width: 30px;
    height: 30px;
    border: solid 2px #ffffff;
  }
}
</style>
